module.exports = __webpack_public_path__ + "img/grzx.37974e87.png";